import React, {Component}       from "react";
import {Text, TouchableOpacity} from "react-native";
import styles                   from "../styles/Styles";

export default class Button extends Component {
    render() {
        return (
            <TouchableOpacity onPress={this.props.onPress}>
                <Text style={styles.button}>{this.props.text}</Text>
            </TouchableOpacity> 
        );
    }
}